import { render, staticRenderFns } from "./ProductsRouterView.vue?vue&type=template&id=e4f22830&scoped=true&"
import script from "./ProductsRouterView.vue?vue&type=script&lang=js&"
export * from "./ProductsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f22830",
  null
  
)

export default component.exports